/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_states_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Zpracování`
};

const da_order_states_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Behandles`
};

const de_order_states_processing = /** @type {(inputs: {}) => string} */ () => {
	return `In Bearbeitung`
};

const en_order_states_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Processing`
};

const es_order_states_processing = /** @type {(inputs: {}) => string} */ () => {
	return `En proceso`
};

const fr_order_states_processing = /** @type {(inputs: {}) => string} */ () => {
	return `En cours de traitement`
};

const hu_order_states_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Feldolgozás alatt`
};

const it_order_states_processing = /** @type {(inputs: {}) => string} */ () => {
	return `In elaborazione`
};

const nl_order_states_processing = /** @type {(inputs: {}) => string} */ () => {
	return `In behandeling`
};

const pl_order_states_processing = /** @type {(inputs: {}) => string} */ () => {
	return `W trakcie realizacji`
};

const pt_order_states_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Em processamento`
};

const sv_order_states_processing = /** @type {(inputs: {}) => string} */ () => {
	return `Behandlas`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_states_processing = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_states_processing(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_states_processing", locale)
	if (locale === "cs") return cs_order_states_processing(inputs)
	if (locale === "da") return da_order_states_processing(inputs)
	if (locale === "de") return de_order_states_processing(inputs)
	if (locale === "en") return en_order_states_processing(inputs)
	if (locale === "es") return es_order_states_processing(inputs)
	if (locale === "fr") return fr_order_states_processing(inputs)
	if (locale === "hu") return hu_order_states_processing(inputs)
	if (locale === "it") return it_order_states_processing(inputs)
	if (locale === "nl") return nl_order_states_processing(inputs)
	if (locale === "pl") return pl_order_states_processing(inputs)
	if (locale === "pt") return pt_order_states_processing(inputs)
	return sv_order_states_processing(inputs)
};
export { order_states_processing as "order_states.processing" }